import React, { useState, useEffect } from 'react';
import GridLoader from 'react-spinners/GridLoader';
import { Text, Flex, FlexProps, useToken } from '@chakra-ui/react';

const DISPLAY_TIMEOUT = 300;

const DataPointsLogo = () => (
  <>
    <Text
      color="gray.900"
      fontSize="8xl"
      fontFamily="'Baskerville', serif"
      textAlign="center"
      mb={6}
    >
      Data
      <Text
        as="span"
        color="yellow.400"
        display="inline"
        fontSize="8xl"
        fontFamily="'Baskerville', serif"
      >
        Points
      </Text>
    </Text>
  </>
);

const Loading: React.FC<
  FlexProps & {
    showLogo?: boolean;
    loaderSize?: number;
  }
> = ({
  width = '100%',
  height = '100%',
  loaderSize = 25,
  showLogo = false,
  ...flexProps
}) => {
  const [gridLoaderColour] = useToken('colors', ['gray.900']);
  const [loaderBoxesBorderRadius] = useToken('radii', ['sm']);
  const [showIndicator, setShowIndicator] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => {
      setShowIndicator(true);
    }, DISPLAY_TIMEOUT);
    return () => clearTimeout(t);
  }, []);

  return showIndicator ? (
    <Flex
      data-testid="loading-spinner"
      w={width}
      h={height}
      justify="center"
      align="center"
      {...flexProps}
    >
      <Flex
        w="100%"
        flexDirection="column"
        alignItems="center"
        sx={{
          div: {
            borderRadius: loaderBoxesBorderRadius,
          },
        }}
      >
        {showLogo && <DataPointsLogo />}
        <GridLoader
          color={gridLoaderColour}
          size={loaderSize}
          margin={Math.ceil(loaderSize / 3)}
        />
      </Flex>
    </Flex>
  ) : null;
};

export default Loading;
